import AppConfigs from 'general/constants/AppConfigs';
import axiosClient from './axiosClient';

const marketingDocumentApi = {
  getAdminDocuments: (params = {}) => {
    const url = '/admin/marketing-documents';
    return axiosClient.get(url, {
      params,
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  createDocument: (params = {}) => {
    const url = '/admin/marketing-documents';
    return axiosClient.post(url, params, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  updateDocument: (marketingDocumentId, params = {}) => {
    const url = `/admin/marketing-documents/${marketingDocumentId}`;
    return axiosClient.put(url, params, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  deleteDocument: (marketingDocumentId) => {
    const url = `/admin/marketing-documents/${marketingDocumentId}`;
    return axiosClient.delete(url, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  getPublishedDocuments: (params = {}) => {
    const url = '/fe/marketing-documents';
    return axiosClient.get(url, {
      params: { ...params, publishedOnly: 1 },
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },
};

export default marketingDocumentApi;
